import React from "react";
import { Link } from "react-router-dom";
import { useBetween } from "use-between";
import _user from "_user";
import Card from "components/card";
import { SlUser, SlOrganization } from "react-icons/sl";
import { MdComputer } from "react-icons/md";
import { VscTerminal } from "react-icons/vsc";

const quickLinks = [
  {
    name: "Usuarios",
    to: "/admin/users",
    icon: <SlUser className="h-6 w-6" />,
    desc: "Gestiona las cuentas de acceso al panel",
  },
  {
    name: "Organizaciones",
    to: "/admin/organizations",
    icon: <SlOrganization className="h-6 w-6" />,
    desc: "Administra las organizaciones registradas",
  },
  {
    name: "Dispositivos",
    to: "/admin/devices",
    icon: <MdComputer className="h-6 w-6" />,
    desc: "Consulta y configura los dispositivos",
  },
  {
    name: "Modelos",
    to: "/admin/models",
    icon: <VscTerminal className="h-6 w-6" />,
    desc: "Revisa los modelos disponibles",
  },
];

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Buenos días";
  if (hour < 19) return "Buenas tardes";
  return "Buenas noches";
};

const MainDashboard = () => {
  const { user } = useBetween(_user);

  return (
    <div className="mt-3">
      <div className="relative overflow-hidden rounded-[20px] bg-gradient-to-br from-brand-400 via-brand-500 to-navy-700 p-8 text-white shadow-card animate-fadeInUp">
        <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -bottom-16 right-24 h-40 w-40 rounded-full bg-white/5" />
        <p className="relative text-sm font-medium text-white/70">
          {getGreeting()}
        </p>
        <h1 className="relative mt-1 text-3xl font-bold">
          👋 Hola, {(user || {}).nombre || "bienvenido"}
        </h1>
        <p className="relative mt-2 max-w-lg text-sm text-white/80">
          Este es tu panel de control. Accede rápidamente a las secciones
          principales desde las tarjetas de abajo.
        </p>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
        {quickLinks.map((link, index) => (
          <Link key={link.name} to={link.to}>
            <Card
              extra={`group h-full cursor-pointer p-5 animate-fadeInUp`}
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="flex items-center gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-500 transition-all duration-300 group-hover:scale-110 group-hover:bg-brand-500 group-hover:text-white dark:bg-navy-700 dark:text-white">
                  {link.icon}
                </div>
                <div>
                  <p className="text-base font-bold text-navy-700 dark:text-white">
                    {link.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {link.desc}
                  </p>
                </div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MainDashboard;
